import OtpInput from 'react-otp-input'
import styled, { css } from 'styled-components'
import colors from '../../constants/colors'
import { OtpProps } from './Otp.types'
import Flex from '../Flex'

const getSizeByNumInputs = (props: number) => {
  if (props <= 4) {
    return css`
      width: 74px !important;
      height: 74px !important;
    `
  }
  return css`
    width: 48px !important;
    height: 48px !important;
  `
}

export const OtpWrapper = styled(Flex)`
  box-sizing: border-box;
  div {
    width: 100%;
    justify-content: space-between;
    gap: 16px;
    column-gap: 8px;
  }
`

export const StyledOtpInput = styled(OtpInput)<OtpProps>`
  input {
    box-sizing: border-box;
    ${(props) => getSizeByNumInputs(props.numInputs)}
    border-radius: 8px;
    border: ${(props) =>
      props.isError ? `1px solid ${colors.red50}` : `1px solid ${colors.black10}`} !important;
    font-size: 24px !important;
    font-weight: 700 !important;
    line-height: 32.68px !important;
  }
`
